import React from "react";
import Image from "next/image";
import ICMWrapper from "@/app/components/icm-wrapper";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

interface HowtoInvestProps {
    activeBullion: string;
    handleDownloadAppClick: () => void;
    heading:string;
}

const HowToInvest: React.FC<HowtoInvestProps> = ({ activeBullion, handleDownloadAppClick,heading }) => {
    const HowToInvestData = [
        {
            img: `${process.env.ICM_IMAGES_URL}png/how-to-${activeBullion.toLowerCase()}-1.png`,
            title: "Create an account",
            text:
                "Download mobile app and register to buy digital " +
                activeBullion.toLowerCase() +
                " in a few steps.",
        },
        {
            img: `${process.env.ICM_IMAGES_URL}png/how-to-${activeBullion.toLowerCase()}-2.png`,
            title: "Select & buy digital " + activeBullion.toLowerCase(),
            text: "Select the option SIP or 1-time buy as per your investment goal",
        },
        {
            img: `${process.env.ICM_IMAGES_URL}png/how-to-${activeBullion.toLowerCase()}-3.png`,
            title: "Make payment",
            text: "Choose or enter the amount which you want to invest and make payment",
        },
    ];

    return (
        <section
            id="section-how-to-invest"
            className="bg-muted-ochre-50 bg-[url('https://assets.incredmoney.com/images/webp/how-to-invest-gold.webp')] bg-[length:90%] bg-no-repeat py-14 md:bg-[length:35%] md:py-s15"
        >
            <h2
                id="section-title"
                className="ml-auto mr-auto max-w-[80%] text-center text-3xl font-semibold leading-[120%] tracking-[-0.48px] text-neutral-950 md:text-6xl"
            >
                {heading}
            </h2>
            <ICMWrapper>
                <div className="icm-container md:px-0">
                <div
                    id="block-container"
                    className="relative flex flex-col items-start justify-between gap-8 pt-s14 md:flex-row md:gap-20 md:py-s14"
                >
                    {HowToInvestData.length > 0 &&
                        HowToInvestData.map((item, index) => {
                            return (
                                <div id={"block-" + (index + 1)} className="flex-1" key={index}>
                                    <div className={`mb-7 rounded-[3rem] bg-white ${index === 2 ? "p-5 md:p-8" : ""}`}>
                                        <Image
                                            id="block-img"
                                            src={item.img}
                                            alt="Create an account"
                                            quality={100}
                                            width={331}
                                            height={331}
                                            className="mx-auto h-auto w-full object-contain object-center"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <h5
                                            id="block-title"
                                            className="mb-1 text-lg font-semibold leading-[130%] md:text-xl"
                                        >
                                            {item.title}
                                        </h5>
                                        <p
                                            id="block-info"
                                            className="text-sm leading-[160%] tracking-[0.14px] md:px-s5"
                                        >
                                            {item.text}
                                        </p>
                                    </div>
                                </div>
                            );
                        })}
                </div>
                <div className="hidden flex-col items-center justify-center gap-4 md:flex md:flex-row">
                    <RegularButton
                        id="btn-download-app"
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityDark-30 hover:text-black md:max-w-fit"
                        label="Download the app"
                        onClick={handleDownloadAppClick}
                    />
                </div>
                </div>
            </ICMWrapper>
        </section>
    );
};

export default HowToInvest;
